import React, { useMemo } from 'react';
import BaseSelectBox from 'components/atoms/base-select-box';
import { smsStatusesDataSource } from 'infrastructure/data-sources/sms-statuses';

import type {
  IBaseSelectBoxOption,
  IBaseSelectBoxProps,
} from 'components/atoms/base-select-box/types';
import type { ISmsStatusItem } from 'infrastructure/data-sources/sms-statuses';

type Options = IBaseSelectBoxOption<ISmsStatusItem['id'], ISmsStatusItem>[];

interface IProps
  extends Omit<IBaseSelectBoxProps<ISmsStatusItem['id']>, 'options'> {
  withAll?: boolean;
}

const SmsStatusSelectBox: React.FC<IProps> = (props) => {
  const { withAll } = props;
  const dataSource = useMemo(
    () => smsStatusesDataSource({ withAll }),
    [withAll],
  );

  const options: Options = useMemo(
    () =>
      dataSource.map((el) => ({
        value: el.id,
        label: el.name,
        record: el,
      })),
    [dataSource],
  );

  return <BaseSelectBox options={options} {...props} />;
};

export default SmsStatusSelectBox;
